<template>
  <div
    class="inner draw"
    v-loading="loading">
    <div
      class="wrap"
      :id="`capture${idNUm}`">
      <canvas
        :id="`canvas${idNUm}`"
        class="fl"
        :width="imgWidth"
        :height="imgHeight"
        @mousedown="canvasDown($event)"
        @mouseup="canvasUp($event)"
        @mousemove="canvasMove($event)"
        @touchstart="canvasDown($event)"
        @touchend="canvasUp($event)"
        @touchmove="canvasMove($event)"
      />
      <!--编辑图片-->
      <img
        class="back"
        crossorigin="anonymous"
        :id="`back${idNUm}`"
        :src="backUrl" >
    </div>
    <div
      id="control"
      class="fl control"
      :style="{ 'height': imgHeight + 'px' }">
      <!--画笔颜色-->
      <div class="canvas-color">
        <h5>
          画笔颜色</h5>
        <ul>
          <li
            v-for="item in colors"
            :key="item"
            :class="{'active':config.lineColor === item}"
            :style="{ background: item }"
            @click="setColor(item)"
          />
        </ul>
      </div>
      <!--画笔-->
      <div class="canvas-brush">
        <h5>画笔</h5>
        <span
          v-for="pen in brushs"
          :key="pen"
          :class="[pen.className,{'active': config.which === pen.which}]"
          @click="setBrush(pen.which)"
        >{{ pen.title }}</span>
      </div>
      <!--操作-->
      <div class="canvas-control">
        <h5>操作</h5>
        <span
          v-for="control in controls"
          :key="control"
          :title="control.title"
          :class="control.className"
          @click="controlCanvas(control.action)"
        >{{ control.title }}</span>
      </div>
      <!-- 生成图像-->
      <div id="canvas-drawImage">
        <h5>生成图像</h5>
        <el-button
          type="primary"
          @click="getImage()">保 存</el-button>
      </div>
    </div>
    <!--存放图片-->
    <div
      class="img-box"
      v-show="imgUrl.length">
      <div
        class="img-item"
        v-for="src in imgUrl"
        :key="src"
      >
        <img :src="src">
        <span
          class="fa fa-close"
          @click="removeImg(src)"/>
      </div>
    </div>
  </div>
</template>
<script>
import html2canvas from 'html2canvas';

export default {
  data () {
    return {
      colors: ['#cccccc', '#fff', '#ffc200', '#f32f15', '#fef4ac', '#5ab639'],
      brushs: [{
        className: 'small',
        which: 'rect',
        title: '矩形'
      }, {
        className: 'middle',
        which: 'clear',
        title: '橡皮'
      }],
      context: {},
      imgUrl: [],
      canvasMoveUse: false,
      // 存储当前表面状态数组-上一步
      preDrawAry: [],
      // 存储当前表面状态数组-下一步
      nextDrawAry: [],
      // 中间数组
      middleAry: [],
      // 配置参数
      config: {
        which: 'rect',
        lineColor: '#cccccc',
        shadowBlur: 2
      },
      oldcanvasX: null, // 初始X坐标
      oldcanvasY: null, // 初始Y坐标
      imgHeight: 600,
      imgWidth: 800,
      loading: false
    };
  },
  props: {
    backUrl: {
      type: String,
      default: '',
    },
    offerSchoolId: {
      type: Number,
      default: 0,
    },
    fieldName: {
      type: String,
      default: '',
    },
    countryId: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    idNUm: {
      type: Number,
      default: 0,
    },
    ext: {
      type: String,
      default: '',
    },
  },
  created () {
    this.$emit('setNav', '在线涂鸦画板');
  },
  mounted () {
    document.getElementById(`back${this.idNUm}`).onload = () => {
      this.imgHeight = document.getElementById(`back${this.idNUm}`).offsetHeight;
      this.controlCanvas('clear');
    };
    console.log(document.querySelector(`#canvas${this.idNUm}`));
    const canvas = document.querySelector(`#canvas${this.idNUm}`);
    this.context = canvas.getContext('2d');
    this.initDraw();
    this.setCanvasStyle();
  },
  computed: {
    controls () {
      return [{
        title: '上一步',
        action: 'prev',
        className: this.preDrawAry.length ? 'active fa fa-reply' : 'fa fa-reply'
      }, {
        title: '下一步',
        action: 'next',
        className: this.nextDrawAry.length ? 'active fa fa-share' : 'fa fa-share'
      }, {
        title: '清除',
        action: 'clear',
        className: (this.preDrawAry.length || this.nextDrawAry.length) ? 'active fa fa-trash' : 'fa fa-trash'
      }];
    }
  },
  methods: {
    isPc () {
      const userAgentInfo = navigator.userAgent;
      const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    removeImg (src) {
      this.imgUrl = this.imgUrl.filter(item => item !== src);
    },
    initDraw () {
      const preData = this.context.getImageData(0, 0, this.imgWidth, this.imgHeight);
      // 空绘图表面进栈
      this.middleAry.push(preData);
    },
    init() {
      this.context.strokeStyle = this.config.lineColor;
      this.context.fillStyle = this.config.lineColor;
    },
    canvasMove (e) {
      if (this.canvasMoveUse) {
        const t = e.target;
        let scrollTop = document.querySelector('.tuya').childNodes[0].scrollTop;
        let canvasX = e.clientX - t.parentNode.offsetLeft;
        let canvasY = (e.clientY - t.parentNode.offsetTop) + scrollTop;
        let clientWidth = document.documentElement.clientWidth;
        let clientHeight = document.documentElement.clientHeight;
        if (this.config.which === 'rect') {
          this.init();
          this.context.beginPath();
          this.context.clearRect(0, 0, clientWidth, clientHeight);
          if (this.middleAry.length !== 0) {
            let middle = this.middleAry[this.middleAry.length - 1];
            this.context.putImageData(middle, 0, 0, 0, 0, clientWidth, clientHeight);
          }
          this.context.rect(
            this.oldcanvasX, this.oldcanvasY,
            canvasX - this.oldcanvasX, canvasY - this.oldcanvasY
          );
          this.context.fill();
          this.context.stroke();
        } else if (this.config.which === 'clear') {
          this.context.clearRect(canvasX - 5, canvasY - 5, 20, 20);
        }
      }
    },
    // mouseup
    canvasUp () {
      const preData = this.context.getImageData(0, 0, this.imgWidth, this.imgHeight);
      if (!this.nextDrawAry.length) {
        // 当前绘图表面进栈
        this.middleAry.push(preData);
      } else {
        this.middleAry = [];
        this.middleAry = this.middleAry.concat(this.preDrawAry);
        this.middleAry.push(preData);
        this.nextDrawAry = [];
      }
      this.canvasMoveUse = false;
    },
    // mousedown
    canvasDown (e) {
      this.canvasMoveUse = true;
      // client是基于整个页面的坐标
      // offset是cavas距离顶部以及左边的距离
      let scrollTop = document.querySelector('.tuya').childNodes[0].scrollTop;
      const canvasX = e.clientX - e.target.parentNode.offsetLeft;
      const canvasY = (e.clientY - e.target.parentNode.offsetTop) + scrollTop;
      this.oldcanvasX = canvasX;
      this.oldcanvasY = canvasY;
      this.setCanvasStyle();
      // 清除子路径
      this.context.beginPath();
      this.context.moveTo(canvasX, canvasY);
      // 当前绘图表面状态
      const preData = this.context.getImageData(0, 0, this.imgWidth, this.imgHeight);
      // 当前绘图表面进栈
      this.preDrawAry.push(preData);
      if (this.config.which === 'clear') {
        this.context.clearRect(canvasX - 5, canvasY - 5, 20, 20);
      }
    },
    // 设置颜色
    setColor (color) {
      this.config.lineColor = color;
    },
    // 设置画还是删除
    setBrush (type) {
      this.config.which = type;
    },
    // 操作
    controlCanvas (action) {
      switch (action) {
        case 'prev':
          if (this.preDrawAry.length) {
            const popData = this.preDrawAry.pop();
            const midData = this.middleAry[this.preDrawAry.length + 1];
            this.nextDrawAry.push(midData);
            this.context.putImageData(popData, 0, 0);
          }
          break;
        case 'next':
          if (this.nextDrawAry.length) {
            const popData = this.nextDrawAry.pop();
            const midData = this.middleAry[this.middleAry.length - this.nextDrawAry.length - 2];
            this.preDrawAry.push(midData);
            this.context.putImageData(popData, 0, 0);
          }
          break;
        case 'clear':
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.preDrawAry = [];
          this.nextDrawAry = [];
          this.middleAry = [this.middleAry[0]];
          break;
        default:
          return false;
      }
    },
    // 生成图片
    getImage () {
      this.loading = true;
      let src = null;
      html2canvas(document.querySelector(`#capture${this.idNUm}`), {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
      }).then((canvas) => {
        src = canvas.toDataURL('image/jpeg');
        this.$http._post({
          url: '/index/base_process/fileEditOfferSchool',
          data: {
            field_name: this.fieldName,
            crm_id: this.$route.params.crm_id,
            offer_school_id: this.offerSchoolId,
            country_id: this.countryId,
            id: this.id,
            file: src,
            ext: this.ext,
          }
        }).then((data) => {
          this.loading = false;
          this.$message.success(data.msg);
          this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
          this.preDrawAry = [];
          this.nextDrawAry = [];
          this.middleAry = [this.middleAry[0]];
          this.$emit('childchange', false);
        });
      });
    },
    // 设置绘画配置
    setCanvasStyle () {
      this.context.shadowColor = this.config.lineColor;
      this.context.strokeStyle = this.config.lineColor;
    }
  }
};
</script>
<style scoped>
  .cut{
    float: left;
  }
  .fix-body {
    position: fixed !important;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
  }
  .back{
    width: 800px;
    position: absolute;
    left:0;
    top:0;
    z-index:1;
  }
  .wrap{
    position: relative;
    z-index:10;
  }
  canvas{
    position: relative;
    z-index:10;
    cursor: pointer;
    top: 0;
  }
  .inner.draw {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .draw h5 {
    margin-bottom: 10px;
  }
  .img-box {
    flex: 1;
    padding-left: 10px;
  }
  .img-box .img-item {
    position: relative;
    display: inline-block;
  }
  .img-box .img-item .fa {
    position: absolute;
    cursor: pointer;
    right: 1px;
    top: -1px;
    font-size: 12px;
    font-weight: 1;
    display: none;
    color: #ccc;
  }
  .img-box .img-item:hover .fa {
    display: block;
  }
  .img-box .img-item .fa:hover {
    color: #f2849e;
  }
  .img-box img {
    border: 1px #ccc solid;
    width: 90px;
    height: 60px;
    margin: 5px;
  }
  .wrap{
    width: 802px;
    min-height: 600px;
    border-right: none;
  }
  .fl{
    float: left;
    display: block;
  }
  .control{
    width: 160px;
    height: 400px;
    border: 1px #585858 solid;
  }
  .control div{
    padding: 5px;
  }
  .canvas-color ul{
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .canvas-color ul li{
    float: left;
    display: inherit;
    width: 12px;
    height: 12px;
    border: 1px #000 solid;
    margin: 10px;
    cursor: pointer;
  }
  .canvas-color .active {
    width: 16px;
    height: 16px;
    border: 1px solid #f2849e;
    margin: 8px;
  }
  .canvas-brush span{
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
  }
  .canvas-brush .small {
    font-size: 12px;
  }
  .canvas-brush .middle {
    font-size: 14px;
  }
  .canvas-brush .big {
    font-size: 16px;
  }

  .canvas-control span{
    display: inline-block;
    font-size: 14px;
    margin-left: 10px;
    cursor: pointer;
  }
  .canvas-control .active,
  .canvas-brush .active {
    color: #f2849e;
  }
  .drawImage {
    width: 100px;
    height: 30px;
    font-size: 12px;
    line-height: 30px;
  }
</style>
<style>
  .tuya .is-fullscreen{
    background: rgba(0,0,0,0.5);
  }
  .control{
    background: #fff;
  }
  .tuya .el-dialog__title{
    color: #fff;
  }
  .tuya .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
  }
  .tuya .tuya-dialog-footer{
    position: relative;
    bottom: 16px;
  }
  .tuya .el-icon-close:before{
    font-size: 30px;
  }
</style>
